import React, { useEffect } from 'react';
import './Home.css';
import Plant from './plant.svg'

export const ExploreButton = () => {
  return (
    <button className='button'>
      Explore Features
    </button>
  );
};

const Home = () => {
  useEffect(() => {
    // Add home-nav class when component mounts
    const navbar = document.querySelector('.navbar');
    if (navbar) {
      navbar.classList.add('home-nav');
    }

    // Cleanup function to remove class when component unmounts
    return () => {
      if (navbar) {
        navbar.classList.remove('home-nav');
      }
    };
  }, []);

  return (
    <div className="home-container">
      <div className="text-content">
        <h1>The Future of Plant Care: <br>
        </br> ReshBit PlantGuard</h1> 
        <p>by ReshBit Solutions presents PlantGuard – Your Smart Solution for Healthy Plants.</p>
        <ExploreButton/>
      </div>
      <div className="image-content">
        <img src={Plant} alt="Plant" />
      </div>
    </div>
  );
}

export default Home;

// Your Plants, Our Technology

//  ReshBit PlantGuard – The Future of Green Living!

